import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoute } from '@shared/constants';
import { AuthService } from './auth.service';

/**
 * Blocks app routes until Pulse user data is loaded, sending the browser to
 * `/loading` when it is not yet available.
 */
export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.user();

  // If the user data is not null, allow the route to be activated
  // Otherwise, fetch user data on the loading component
  if (user.isInitialized) {
    return true;
  }

  router.navigate([AppRoute.Loading]);
  return false;
};
